import { render, staticRenderFns } from "./ProjektStartenLogo.vue?vue&type=template&id=8c668276&"
import script from "./ProjektStartenLogo.vue?vue&type=script&lang=js&"
export * from "./ProjektStartenLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports